var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RunGallery',{attrs:{"dataNamespace":_vm.nodeId,"data":_vm.node.parameters,"showBack":_vm.showBack,"isLast":_vm.isLast},on:{"back":_vm.onBack,"end":_vm.onEnd}})}
var staticRenderFns = []

export { render, staticRenderFns }